// extracted by mini-css-extract-plugin
module.exports = {"menu":"sidebar_menu__24nKY"};